import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import styled from 'styled-components'
import { Check } from 'styled-icons/fa-solid/Check'
import { Times } from 'styled-icons/fa-solid/Times'

const middle = svg => styled(svg)`
  vertical-align: middle;
`

class Switcher extends React.Component {

  render() {
    const { id, className, size, bsStyle, label, labelRight, disabled, round, checked, onChange } = this.props
    const switchClass = cx(
      'switcher',
      disabled: disabled,
      {'switcher-blank' : !this.props.children },
      {'switcher-rounded' : round },
      {'switcher-sm' : size === 'small' },
      {'switcher-lg' : size === 'large' },
      {'switcher-primary' : bsStyle === 'primary' },
      {'switcher-success' : bsStyle === 'success' },
      {'switcher-danger' : bsStyle === 'danger' },
      {'switcher-warning' : bsStyle === 'warning' },
      {'switcher-info' : bsStyle === 'info' },
      className
    )

    const Left = typeof label === 'function' && middle(label)
    const Right = typeof labelRight === 'function' && middle(labelRight)

    return (
      <label htmlFor={id} className={switchClass} style={this.props.style}>
        <input type='checkbox' id={id} onChange={onChange} checked={checked} disabled={disabled}/>
        <div className='switcher-indicator'>
          <div className='switcher-yes'>{typeof label === 'function' ? <Left size={14}/> : label }</div>
          <div className='switcher-no'>{typeof labelRight === 'function' ? <Right size={14}/> : labelRight }</div>
        </div>
        { this.props.children }
      </label>
    )
  }
}

Switcher.displayName = 'Switch Button'
Switcher.version = '1.0.0'
Switcher.defaultProps = {
  id          : 'switcher',
  label       : Check,
  labelRight  : Times,
  checked     : true,
  disabled    : false,
  size        : '',
  bsStyle     : '',
  onChange    : () => {}
}
Switcher.propTypes = {
  id          : PropTypes.string,
  label       : PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
  labelRight  : PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.func]),
  checked     : PropTypes.bool,
  disabled    : PropTypes.bool,
  size        : PropTypes.string,
  bsStyle     : PropTypes.string,
  onChange    : PropTypes.func
}

export default Switcher



// WEBPACK FOOTER //
// ./src/components/widgets/Switcher.js